export default __webpack_public_path__ + "static/media/scenarios_icon_black.524d80f6.svg";